var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.isMap)?[_c('g-map')]:[_c('l-map')]],2)
}
var staticRenderFns = []

export { render, staticRenderFns }